import React from 'react';
import './styles/dhl-email.scss';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import EmailFooter from '../email-footer';
import { FlexDiv, Image } from '../../../design-system/containers';
import { formatDate, resourcePath } from '../../../../utils/helpers';
import EmailPriorityDisclaimer from '../email-priority-disclaimer';
import EmailTrans from '../../email-i18next-trans';

function DefaultEmail({
    ui,
    userName,
    handleLinkClick,
    handleLinkMouseLeave,
    handleLinkMouseEnter,
}) {
    const { t } = useTranslation('assessment');
    const { link, links, email, personalizedData = {} } = ui;
    const {
        text,
        from_name,
        from_address,
        footer,
        extraLogo,
        showHighPriority,
    } = email;
    const { spoofedDomain, companyDomain } = personalizedData;
    const yesterday = ((d) => new Date(d.setDate(d.getDate() - 1)))(new Date());
    const today = new Date();
    const inOneWeek = ((d) => new Date(d.setDate(d.getDate() + 7)))(new Date());

    return (
        <>
            <div className="email-text">
                {showHighPriority && <EmailPriorityDisclaimer />}
                {extraLogo && (
                    <FlexDiv my={20}>
                        <Image
                            src={resourcePath(extraLogo.src || extraLogo)}
                            alt={t('icon')}
                            height={extraLogo.height || 21}
                        />
                    </FlexDiv>
                )}
                <div className="body">
                    <EmailTrans
                        translatedString={t(text, {
                            username: userName ? userName.split(' ')[0] : '',
                            sender_name: from_name
                                ? from_name.split(' ')[0]
                                : '',
                            sender_full_name: from_name ? from_name : '',
                            sender_from_address: from_address
                                ? from_address
                                : '',
                            yesterday: formatDate(yesterday),
                            today: formatDate(today),
                            inOneWeek: formatDate(inOneWeek),
                            spoofedDomain: spoofedDomain ? spoofedDomain : '',
                            companyDomain: companyDomain ? companyDomain : '',
                        })}
                        link={link}
                        links={links}
                        linkFunctionality={{
                            handleLinkClick,
                            handleLinkMouseLeave,
                            handleLinkMouseEnter,
                        }}
                    />
                </div>
                {footer && (
                    <EmailFooter
                        footer={footer}
                        handleLinkClick={handleLinkClick}
                        handleLinkMouseLeave={handleLinkMouseLeave}
                        handleLinkMouseEnter={handleLinkMouseEnter}
                        link={footer.link}
                    />
                )}
            </div>
        </>
    );
}

export default observer(DefaultEmail);
